<template>
  <div class="login-page auth">
    <terms-form
      :display-terms="showTerms"
      @terms-accepted="onTermsAccepted"
    />
    <div class="container">
      <div class="callout">
        <img
          src="../../assets/myvisionlink-rewards-light.svg"
          alt="VisionLink"
        >
        <h1>Access up-to-date plan details, forecasts, and payments.</h1>
        <standard-button @click="gotoVisionLink">
          Click here to learn<br>more about VisionLink
        </standard-button>
      </div>
    </div>
    <div class="container">
      <div
        v-show="showDefaultLogin"
        class="login-page-form card"
      >
        <h2>Sign on to access your plan.</h2>
        <input-field
          @input="evtChangeEmail"
          @keyup.enter="login"
        >
          Email
        </input-field>
        <password-field
          @input="evtChangePassword"
          field-type="password"
          @keyup.enter="login"
        >
          Password
        </password-field>
        
        <div v-if="checkedMediaQuery" :style="isMobile ? 'display: flex; justify-content: center;' : 'padding:0px 50px 25px;'">
          <RecaptchaV2
            :key="isMobile ? 'compact' : 'normal'"
            :size="isMobile ? 'compact' : 'normal'"
            @widget-id="handleWidgetId"
            @error-callback="handleErrorCallback"
            @expired-callback="handleExpiredCallback"
            @load-callback="evtValidate"
          />
        </div>
        <button v-on:click="login" class="br-login-standard-button">Login</button>

        <a
          href="#"
          class="forgot-link"
          @click="showForgot=true"
        >Forgot Password</a>
        <div class="tou-and-pp">
          <a href="/site/terms-of-use.pdf">Terms of Use</a> <a href="/site/privacy-policy.pdf">Privacy Policy</a>
        </div>
      </div>
      <div
        v-if="showSingleSignOn"
        class="login-page-form"
      >
        <div style="margin-bottom: 10px;">
          Logging you into Rewards...
        </div>
      </div>
      <div
        v-if="showForgot"
        class="login-page-form card"
      >
        <input-field
          @input="evtChangeEmail"
          @keyup.enter="login"
        >
          Email
        </input-field>

        <div v-if="checkedMediaQuery" :style="isMobile ? 'display: flex; justify-content: center;' : 'padding:0px 50px 25px;'">
          <RecaptchaV2
            :key="isMobile ? 'compact' : 'normal'"
            :size="isMobile ? 'compact' : 'normal'"
            @widget-id="handleWidgetId"
            @error-callback="handleErrorCallback"
            @expired-callback="handleExpiredCallback"
            @load-callback="evtValidate"
          />
        </div>
        <button v-on:click="forgotPassword" class="br-login-standard-button">Submit</button>

        <a
          href="#"
          class="forgot-link"
          @click="showForgot=false"
        >Back to Login</a>
        <div class="tou-and-pp">
          <a href="/site/terms-of-use.pdf">Terms of Use</a> <a href="/site/privacy-policy.pdf">Privacy Policy</a>
        </div>
      </div>
      <div
        v-if="showResetPassword && !showTerms"
        class="login-page-form login-page-reset"
      >
        <div style="margin-bottom: 10px;">
          You must reset your password to continue.
        </div>
        <input-field @input="evtChangeEmail">
          Email
        </input-field>
        <password-field
          field-type="password"
          @input="evtChangeOldPassword"
        >
          Old Password
        </password-field>
        <password-field
          field-type="password"
          @input="evtChangeNewPassword"
        >
          New Password
        </password-field>
        <password-field
          field-type="password"
          @input="evtChangeNewPasswordConfirm"
        >
          Confirm New Password
        </password-field>
        <standard-button @click="updatePassword">
          Update
        </standard-button>
      </div>
      <va-modal
        v-if="showError"
        v-model="showError"
        title="Login Failed"
        close-button
      >
        <div>{{ errorMessage }}</div>
      </va-modal>
      <va-modal
        v-if="showForgotConfirmation"
        v-model="showForgotConfirmation"
        title="Request Submitted"
        close-button
      >
        <div>An email has been sent to provide you with further instructions. If you don't see it, please check your spam or junk folder.</div>
      </va-modal>
      <va-modal
        v-if="showResetPasswordMessage"
        v-model="showResetPasswordMessage"
        title="Reset Password"
        close-button
      >
        <div>{{ passwordResetMessage }}</div>
      </va-modal>
    </div>
  </div>
</template>

<script>
import { RecaptchaV2 } from 'vue3-recaptcha-v2';
import InputField from "@/components/elements/InputField";
import PasswordField from "@/components/elements/PasswordField";
import StandardButton from "@/components/elements/StandardButton";
import TermsForm from "./TermsForm";
export default {
    name: "BrLogin",
	components:{
		RecaptchaV2,
		InputField,
		PasswordField,
		StandardButton,
		TermsForm
	},
    data() {
        return {
			email: "",
			password: "",
			showError: false,
			errorMessage: "XXX",
			showSingleSignOn: false,
			showForgot: false,
			showForgotConfirmation: false,
			showResetPassword: false,
			showResetPasswordMessage: false,
			passwordResetMessage: "",
			oldPassword: null,
			newPassword: null,
			newPasswordConfirm: null,
			showTerms: false,
			termsAccepted: false,
			token: null,
			isMobile: false,
			mediaQueryList: null,
			checkedMediaQuery: false,
		}
    },
	computed:{
		showDefaultLogin(){
			return !this.showSingleSignOn && !this.showForgot && !this.showResetPassword && !this.showTerms;
		}
	},
	unmounted() {
		this.mediaQueryList.removeEventListener("change", this.handleMediaQueryChange);
	},
    mounted() {
	this.init();
	// Create the query list.
	this.mediaQueryList = window.matchMedia("(max-width: 500px)");
	// Run the orientation change handler once.
	this.handleMediaQueryChange(this.mediaQueryList);
	// Add the callback function as a listener to the query list.
	this.mediaQueryList.addEventListener("change", this.handleMediaQueryChange);
    },
    methods: {
		init(){
			if(this.$route.path === '/single-sign-on'){
				this.showSingleSignOn = true;
				this.$apiManager.get("single-sign-on").then(
					(pack) => this.loginResults(pack),
					() => this.dataFailure(),
				);
			}
		},
		evtChangeEmail(value) {
			this.email = value;
		},
		evtChangePassword(value) {
			this.password = value;
		},
		evtChangeOldPassword(value) {
			this.oldPassword = value;
		},
		evtChangeNewPassword(value) {
			this.newPassword = value;
		},
		evtChangeNewPasswordConfirm(value) {
			this.newPasswordConfirm = value;
		},

		evtValidate(response) {
            this.token = response;
        },

        handleWidgetId(widgetId) {
            console.log('widget ID: ' + widgetId);
        },

        handleErrorCallback() {
            console.log('error callback');
        },

        handleExpiredCallback() {
            console.log('expired callback');
        },
		login(){
			let sRoute = this.$unifiedApiManager.baseURL + 'api/login';
			let oBody = { email: this.email, password: this.password };
			let sMethod = 'POST';
            let oHeaders = { 'Content-Type': 'application/json' };
			fetch(sRoute, { method: sMethod, body: JSON.stringify(oBody), headers: oHeaders, credentials: 'include' })
				.then((res) => res.json())
				.then((data) => {
					this.$unifiedApiManager.loginInfo = data;
					this.$apiManager.post("login", {
						email: this.email,
						password: this.password,
						recaptchaResponse: this.token,
						acceptedTerms: this.termsAccepted
					}).then(
						(pack) => this.loginResults(pack),
						() => this.dataFailure(),
					);
				});
		},
		loginResults(pack){
			if(pack.data && pack.data.success){
				if(pack.data.token === 'adminUrl'){
					window.location.href = pack.data.adminUrl;
					return;
				}
				this.$apiManager.token = pack.data.token;
				if(pack.data.adminUrl){
					this.$apiManager.adminUrl = pack.data.adminUrl;
				}
				this.$apiManager.get("user").then(
					(pack) => this.userDataSuccess(pack),
					() => this.dataFailure(),
				);
			} else if(pack.data) {
				this.showSingleSignOn = false;
				switch(pack.data.errorCode){
					case "must-change-password":
						this.showResetPassword = true;
						break;
					case "must-accept-terms":
						this.showTerms = true;
						break;
					case "must-accept-terms-and-change-password":
						this.showTerms = true;
						this.showResetPassword = true;
						break;
					case "try-again":
						this.errorMessage = "Error processing request, please try again.";
						this.showError = true;
						break;
					default:
						this.errorMessage = "The email or password you provided is incorrect.";
						this.showError = true;
						break;
				}
			} else {
				this.errorMessage = "The email or password you provided is incorrect.";
				this.showError = true;
			}
		},
		userDataSuccess(pack){
			if(pack.data && pack.data.success){
				this.$dataDirectory.userData = pack.data;
				this.$router.push("/dashboard");
			} else {
				this.dataFailure();
			}
		},
		dataFailure(){
			this.errorMessage = "There was an issue communicating with the server. Please try again later.";
			this.showError = true;
		},
		forgotPassword(){
			this.$apiManager.post("forgot-password", {
				email: this.email,
				recaptchaResponse: this.token
			}).then(
				(pack) => this.forgotSubmitted(pack),
				() => this.dataFailure()
			);
		},
		forgotSubmitted(pack){
			if(pack.data && pack.data.success){
				this.showForgotConfirmation = true;
			} else {
				this.errorMessage = "There was an issue communicating with the server. Please try again later.";
				this.showError = true;
			}
		},
		updatePassword(){
			if(!this.newPassword || this.newPassword.trim() === ""){
				this.passwordResetMessage = "Please provide your old password.";
				this.showResetPasswordMessage = true;
				return;
			}if(!this.oldPassword || this.oldPassword.trim() === ""){
				this.passwordResetMessage = "Please set your new password.";
				this.showResetPasswordMessage = true;
				return;
			}
			if(this.newPassword === this.newPasswordConfirm){
				this.$apiManager.post("new-password-login", {
					email: this.email,
					oldPassword: this.oldPassword,
					newPassword: this.newPassword,
					acceptedTerms: this.termsAccepted
				}).then(
					(pack) => this.passwordUpdated(pack),
					() => this.dataFailure()
				);
			} else {
				this.passwordResetMessage = "Password and password confirmation do not match.";
				this.showResetPasswordMessage = true;
			}
		},
		cancelPassword(){
			this.showResetPasswordMessage = false;
		},
		passwordUpdated(pack){
			if(pack.data && pack.data.success){
				this.$apiManager.token = pack.data.token;
				if(pack.data.adminUrl){
					this.$apiManager.adminUrl = pack.data.adminUrl;
				}
				this.$apiManager.get("user").then(
					(pack) => this.userDataSuccess(pack),
					() => this.dataFailure(),
				);
			} else {
				this.passwordResetMessage = "Unable to verify current login credentials. Please check the email (username) and try your current password again.";
				this.oldPassword = null;
				this.showResetPasswordMessage = true;
			}
		},
		onTermsAccepted(){
			this.showTerms = false;
			this.termsAccepted = true;
			if(!this.showResetPassword){
				this.login();
			}
		},
		gotoVisionLink(){
			window.open('https://visionlink.co');
		},
		handleMediaQueryChange(evt) {
			if (evt.matches) {
				this.isMobile = true
			} else {
				this.isMobile = false
			}
			this.checkedMediaQuery = true;
		}
	}
}
</script>
<style lang="scss" scoped>
@import '@/scss/_auth.scss';

.br-login-standard-button {
	color: #ffffff;
	background-color: #479dea;
	border: none;
	border-radius: 20em;
	font-size: 14px;
	padding: 8px 25px;
	cursor: pointer;
	text-decoration: none;
	font-family: "Lexend Deca", sans-serif;
	letter-spacing: 0.08em;
	font-weight: 500;
	height: 36px;

	&:hover{
		color: #ffffff;
		background: linear-gradient(90deg, #479dea 31.5%, #de97ff);
	}
}
</style>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.login-page{
	&-form{
		max-width: 470px;
		border-radius: 15px;
		text-align: center;
		padding: 40px;
		position: relative;
		background-color: #FFFFFF;

		@media screen and (max-width: 500px) {
			max-width: calc(100vw - 50px);
		}
	}

	&-reset{
		height: 400px;
		width: 625px;
		padding: 50px 25px;
		margin: calc(50vh - 225px) auto;
	}

	.forgot-link{
		display: block;
		margin-top: 20px;
		font-size: 14px;
	}
	.tou-and-pp{
		display: flex;
		gap: 30px;
		font-size: 14px;
		border-top: 1px solid variables.$color-divider;
		justify-content: center;
		margin-top: 20px;
		padding-top: 20px;

		a{
			width: auto !important;
		}
	}
}
</style>
